import React from 'react';
import _ from 'lodash';
import { whooshkaaPlayer } from '../lib/podcastHelper';

const PodcastButton = ({ type, value }) => {
  const getPodcast = (type, value) => {
    if (_.lowerCase(type) == 'whooshkaa') {
      whooshkaaPlayer(value);
    } else {
      window.open(value, '_blank');
    }
  };

  return (
    <React.Fragment>
      <button
        data-pa-click={JSON.stringify({
          link: `PodcastButton-button-${type}`,
          event_name: "brc_podcast_clicked"
        })}
        className="load-more-btn"
        onClick={() => getPodcast(type, value)}
      >
        {type}
      </button>
    </React.Fragment>
  );
};

export default PodcastButton;
